import { useState } from 'react';
import { NetflixRow } from './NetflixRow';
import { X, ExternalLink, MapPin, Calendar } from 'lucide-react';

export const PhotoGallery = () => {
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  const photos = [
    {
      title: "ECS Federal Summit",
      location: "Washington, D.C.",
      date: "October 2023",
      description: "Speaking at the ECS Federal Summit on cloud security governance and FedRAMP modernization strategies for federal agencies.",
      imageUrl: "https://media.licdn.com/dms/image/v2/D5622AQHpFl0RzsT_FA/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1698083364622?e=1762992000&v=beta&t=jAdvp9290g2xdqRXPRX5p-uNw7Wjv7Lliq44VcMZtTg",
      category: "Federal Summit"
    },
    {
      title: "Atlantic Council Cybersecurity Initiative",
      location: "Washington, D.C.",
      date: "October 2023",
      description: "Participating in Atlantic Council discussions on global cybersecurity policy and international cooperation frameworks.",
      imageUrl: "https://media.licdn.com/dms/image/v2/D5622AQEexk--lAZh-A/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1697470743253?e=1762992000&v=beta&t=1sRAcIQQONNouehuKVuPMTljBnLSXWO9yVDbYoWbtOU",
      category: "International Policy"
    },
    {
      title: "Atlantic Council Policy Discussion",
      location: "Washington, D.C.",
      date: "October 2023",
      description: "Deep dive policy discussions on cybersecurity resilience and national security implications of emerging technologies.",
      imageUrl: "https://media.licdn.com/dms/image/v2/D5622AQHEUMEnQ7hiCQ/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1697470768845?e=1762992000&v=beta&t=Ciz0OBXN7YT8XGMEn3ZLKUUfrb6SoWGAe7NJLTosXjc",
      category: "International Policy"
    },
    {
      title: "National Cybersecurity Alliance Conference",
      location: "National Harbor, MD",
      date: "January 2024",
      description: "Keynote presentation on building resilient cybersecurity frameworks for critical infrastructure protection.",
      imageUrl: "https://media.licdn.com/dms/image/v2/D5622AQFiSbXmOHlurA/feedshare-shrink_1280/feedshare-shrink_1280/0/1705948530387?e=1762992000&v=beta&t=43ZSCYtJjjS-G_FUvaK56nXYrR60C9Y1KeyhKq_3Bgw",
      category: "Industry Conference"
    },
    {
      title: "National Cybersecurity Alliance Panel",
      location: "National Harbor, MD",
      date: "January 2024",
      description: "Panel discussion on public-private partnerships in cybersecurity and collaborative threat intelligence sharing.",
      imageUrl: "https://media.licdn.com/dms/image/v2/D5622AQFRqiNf9l_Gjg/feedshare-shrink_1280/feedshare-shrink_1280/0/1705948530566?e=1762992000&v=beta&t=sILe8mwccCTN3oW2-d6KKeTFyq9APmmYhzNZt7roO5w",
      category: "Industry Conference"
    },
    {
      title: "Cybersecurity Summit Keynote",
      location: "Phoenix, AZ",
      date: "October 2023",
      description: "Delivering keynote address on strategic cybersecurity leadership and enterprise risk transformation.",
      imageUrl: "https://media.licdn.com/dms/image/v2/D5622AQFwBLT3Q6kVzA/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1698679602161?e=1762992000&v=beta&t=KGZIc0HhqFTA7BaeM-d7Sm6Q9SOhQrIYVg4AZk5MACE",
      category: "Industry Summit"
    },
    {
      title: "Cybersecurity Summit Panel",
      location: "Phoenix, AZ",
      date: "October 2023",
      description: "Leading panel discussion on AI governance and regulatory compliance in the age of artificial intelligence.",
      imageUrl: "https://media.licdn.com/dms/image/v2/D5622AQFmRRPZTwuiHg/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1698679602471?e=1762992000&v=beta&t=r7deR5Y_Q-bG7E2AE3LPT8zU1yl7LCb3uG6TY9Av42E",
      category: "Industry Summit"
    },
    {
      title: "Cybersecurity Summit Networking",
      location: "Phoenix, AZ",
      date: "October 2023",
      description: "Networking with industry leaders and discussing emerging trends in cybersecurity risk management.",
      imageUrl: "https://media.licdn.com/dms/image/v2/D5622AQFxL0oqb6e2ig/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1698679602192?e=1762992000&v=beta&t=V7Zp6rEKOx8cadWgyPaWLUe0lgv54PBvX8tuUNP_UoA",
      category: "Industry Summit"
    },
    {
      title: "Strauss Center International Security & Law",
      location: "Austin, TX",
      date: "February 2024",
      description: "Academic symposium on international cybersecurity law and policy frameworks for global cooperation.",
      imageUrl: "https://media.licdn.com/dms/image/v2/D5622AQE_ZKQ-tdNBfQ/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1707151597981?e=1762992000&v=beta&t=Y88QhcoIqnmEJQUDoreZbaAyd2wBCzsZCjdvKzw-gYA",
      category: "Academic Symposium"
    },
    {
      title: "Strauss Center Policy Workshop",
      location: "Austin, TX",
      date: "February 2024",
      description: "Interactive workshop on cybersecurity policy development and implementation strategies for government agencies.",
      imageUrl: "https://media.licdn.com/dms/image/v2/D5622AQHAAH-c0OTNWw/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1707151600105?e=1762992000&v=beta&t=LS_A6eCUntr5bHcl7yq8K60lDOveCUxHVaYHWnV9yxA",
      category: "Academic Symposium"
    },
    {
      title: "Strauss Center Strategic Discussion",
      location: "Austin, TX",
      date: "February 2024",
      description: "Strategic roundtable on cybersecurity challenges in critical infrastructure and national security implications.",
      imageUrl: "https://media.licdn.com/dms/image/v2/D5622AQEsKqM_P3BMtA/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1707151596577?e=1762992000&v=beta&t=lm9X0MbDbpKj0zHGJhmQNEESIiGTVwfG62ZZVK0GVtk",
      category: "Academic Symposium"
    }
  ];

  const PhotoCard = ({ photo, index, onClick }) => {
    const [imageError, setImageError] = useState(false);

    return (
      <div className="netflix-card cursor-pointer" onClick={() => onClick(photo)}>
        <div className="netflix-card-image relative group overflow-hidden">
          {!imageError ? (
            <img 
              src={photo.imageUrl}
              alt={photo.title}
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
              onError={() => setImageError(true)}
            />
          ) : (
            <div className="flex items-center justify-center h-full bg-gradient-to-br from-netflix-red to-netflix-gray-200">
              <div className="text-white text-center">
                <div className="text-2xl mb-2">📸</div>
                <div className="text-sm">{photo.category}</div>
              </div>
            </div>
          )}
          
          {/* Overlay */}
          <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
            <div className="p-4 text-white">
              <div className="text-sm font-semibold">{photo.category}</div>
              <div className="text-xs opacity-80">{photo.date}</div>
            </div>
          </div>
        </div>
        
        <div className="netflix-card-content">
          <div className="netflix-card-title">{photo.title}</div>
          <div className="netflix-card-subtitle flex items-center space-x-2 text-netflix-gray-400">
            <MapPin className="w-3 h-3" />
            <span>{photo.location}</span>
            <span>•</span>
            <Calendar className="w-3 h-3" />
            <span>{photo.date}</span>
          </div>
          
          <div className="mt-2 mb-2">
            <span className="netflix-badge netflix-badge-secondary text-xs">
              {photo.category}
            </span>
          </div>
          
          <div className="netflix-card-description">{photo.description}</div>
        </div>
      </div>
    );
  };

  const PhotoModal = ({ photo, onClose }) => {
    if (!photo) return null;

    return (
      <div className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4">
        <div className="relative max-w-6xl w-full">
          <button 
            onClick={onClose}
            className="absolute -top-12 right-0 text-white hover:text-netflix-red transition-colors z-10"
          >
            <X className="w-8 h-8" />
          </button>
          
          <div className="bg-netflix-black rounded-lg overflow-hidden">
            <div className="grid lg:grid-cols-2 gap-0">
              {/* Image */}
              <div className="relative">
                <img 
                  src={photo.imageUrl}
                  alt={photo.title}
                  className="w-full h-96 lg:h-full object-cover"
                />
              </div>
              
              {/* Details */}
              <div className="p-8">
                <div className="mb-4">
                  <span className="netflix-badge netflix-badge-secondary text-sm">
                    {photo.category}
                  </span>
                </div>
                
                <h2 className="text-3xl font-bold text-white mb-4">{photo.title}</h2>
                
                <div className="space-y-3 mb-6">
                  <div className="flex items-center space-x-2 text-netflix-gray-400">
                    <MapPin className="w-4 h-4" />
                    <span>{photo.location}</span>
                  </div>
                  <div className="flex items-center space-x-2 text-netflix-gray-400">
                    <Calendar className="w-4 h-4" />
                    <span>{photo.date}</span>
                  </div>
                </div>
                
                <p className="text-netflix-gray-400 leading-relaxed mb-6">
                  {photo.description}
                </p>
                
                <div className="space-y-3">
                  <h3 className="text-lg font-semibold text-white">Event Highlights</h3>
                  <div className="space-y-2 text-netflix-gray-400 text-sm">
                    <div>• Strategic cybersecurity leadership presentation</div>
                    <div>• Industry expert panel discussions</div>
                    <div>• Networking with government and industry leaders</div>
                    <div>• Policy and framework development insights</div>
                  </div>
                </div>
                
                <button 
                  onClick={() => window.open(photo.imageUrl, '_blank')}
                  className="mt-6 flex items-center space-x-2 netflix-btn-info"
                >
                  <ExternalLink className="w-4 h-4" />
                  <span>View Full Image</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <NetflixRow title="Professional Gallery" id="gallery">
        {photos.map((photo, index) => (
          <PhotoCard 
            key={index} 
            photo={photo} 
            index={index} 
            onClick={setSelectedPhoto}
          />
        ))}
      </NetflixRow>
      
      {selectedPhoto && (
        <PhotoModal 
          photo={selectedPhoto} 
          onClose={() => setSelectedPhoto(null)} 
        />
      )}
    </>
  );
};